import { render } from "./EditTeacher.vue?vue&type=template&id=06adf62f&scoped=true"
import script from "./EditTeacher.vue?vue&type=script&lang=js"
export * from "./EditTeacher.vue?vue&type=script&lang=js"

import "./EditTeacher.vue?vue&type=style&index=0&id=06adf62f&scoped=true&lang=css"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-06adf62f"]])

export default __exports__